import { QuoteType } from "../../types/mainModulTypes"
import BaseQuoteText from "../common/BaseQuoteText"

export default function Quote(props: QuoteType) {
    const getShade = (shade?: string): string => {
        if (shade?.includes("quoteColorLight")) return "bg-base-200"
        if (shade?.includes("quoteColorSuperLight")) return "bg-base-300"
        if (shade?.includes("quoteColorWhite")) return "bg-none"
        if (shade?.includes("quoteColorPrimary")) return "bg-base-100"
        if (shade?.includes("quoteColorOptional")) return "bg-info"
        return ""
    }

    
    return (
        <div className="md:px-4">
            <div
                className={`max-w-content mx-auto px-12 flex flex-col items-center justify-center md:rounded-default py-16 gap-3 ${getShade(
                    props.quoteColor
                )}`}>
                <BaseQuoteText text={props.quoteText} author={props.quoteAuthor} isQuoteWhite={props.quoteTextColorToggle} />
            </div>
        </div>
    )
}
